<div class="filtro-cargos-contatos flex-col gap-6 flex">
    <div class="filtros__header flex items-center justify-between">
        <h3 class="text-sm font-medium text-brand-purple-300">{{ titulo }}</h3>
        <div class="actions flex items-center gap-4">
            <button type="button" class="text-brand-primary" (click)="removerFiltro(undefined, true)">
                <span class="material-symbols-outlined filled">
                    delete
                </span>
            </button>
            <button class="text-brand-primary" (click)="cancelarFiltro()">
                <span class="material-symbols-outlined">
                    close
                </span>
            </button>
        </div>
    </div>

    <div class="filtros__conteudo flex-1" data-filter-group>
        <div class="input-group icon--after">
            <ng-select [items]="opcoesDisponiveis" bindLabel="valor" bindValue="chave" [typeahead]="pesquisa$"
                placeholder="Pesquisar..." notFoundText="Nenhum item encontrado"
                typeToSearchText="Digite para pesquisar..." addTagText="Adicionar novo item" [searchable]="true"
                [clearable]="true" (change)="adicionarFiltro($event)" class="sem-seta form-control" [closeOnSelect]="true"
                loadingText="Carregando..." [loading]="loading">
            </ng-select>
            <span class="material-symbols-outlined icon" style="color: #6b7280">keyboard_arrow_down</span>
        </div>

        <div class="list-wrapper mt-4">
            <ul class="space-y-2" data-filter-list>
                <li *ngFor="let item of itensSelecionadosInterno"
                    class="bg-brand-purple-50 p-2 text-sm flex items-center min-h-8 rounded">
                    {{ item.valor }}
                    <button type="button" class="btn text-brand-primary ml-auto" (click)="removerFiltro(item)">
                        <span class="material-symbols-outlined filled">delete</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>

    <footer class="filtros_footer flex items-center justify-between gap-2 mt-4">
        <button class="btn btn-secondary flex-1" (click)="cancelarFiltro()">Cancelar</button>
        <button class="btn btn-primary flex-1" (click)="salvarFiltro()">OK</button>
    </footer>
</div>